import { Component, EventEmitter, Input, Output, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';

import { File } from '@core/objects/file';
import { WysiwygData } from '@core/models/wysiwyg-data.model';

@Component({
    selector: 'app-share-send-box',
    templateUrl: './send-box.component.html',
    styleUrls: ['./send-box.component.scss'],
    providers: []
})
export class ShareSendBoxComponent implements OnInit, OnChanges {
    @Input() files: Array<File> = [];
    @Input() subjectPlaceholder: string = "";
    @Input() defaultMessage: string;
    @Input() form: FormGroup;
    @Input() maxEmails: number = 0;
    @Output() emailsChanged = new EventEmitter<number>();

    public message: FormControl = new FormControl();
    public subject: FormControl = new FormControl();
    public emails = new FormControl([]);
    public messageContent: string = '';

    constructor(private fb: FormBuilder) {}

    ngOnInit(){
        this.init();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.maxEmails && !changes.maxEmails.firstChange) {
            this.handleMaxEmailsChange();
        }
        if (changes.defaultMessage && !changes.defaultMessage.firstChange) {
            this.message.setValue(this.defaultMessage);
        }
        if (changes.subjectPlaceholder && !changes.subjectPlaceholder.firstChange) {
            this.subject.setValue(this.subjectPlaceholder);
        }
    }

    init() {
        this.message = new FormControl(this.defaultMessage);
        this.subject = new FormControl(this.subjectPlaceholder);
        this.form.addControl("subject", this.subject);
        this.form.addControl("message", this.message);
        this.form.addControl("emails", this.emails);
    }

    onMessageChange(msgData: WysiwygData){
        // Here we update current FormControl to set value to save with the form.
        this.messageContent = msgData.html; // need to be updated to send to save message
        this.message.setValue(msgData.html);
    }

    protected handleMaxEmailsChange() {
        const currentEmails = this.form.get('emails').value;
        if (this.maxEmails !== 0) {
            if (currentEmails.length > this.maxEmails) {
                this.form.get('emails').setValue(currentEmails.slice(0, this.maxEmails));
                this.emails.setValue(this.form.get('emails').value)
            }
        }
    }

}
